<script setup lang="ts">
import { computed, reactive, ref } from "vue";
import AdminLayout from "./AdminLayout.vue";
import { AdminFetcher } from "../../api/adminFetcher";
import { toastErr, toastOk } from "../../utils/toasts";
const saved = ref<typeof data | undefined>();
const data = reactive({
  summary_prompt: "",
  split_full_text_prompt: "",
  max_char: 0,
  model: "",
});
AdminFetcher.get({
  path: "/key-value-settings",
})
  .then((resp: typeof data) => {
    saved.value = JSON.parse(JSON.stringify(resp));
    data.summary_prompt = resp.summary_prompt;
    data.split_full_text_prompt = resp.split_full_text_prompt;
    data.max_char = resp.max_char;
    data.model = resp.model;
  })
  .catch(() => {
    toastErr("Ошибка загрузки настроек");
  });
const saveSettings = async () => {
  if (JSON.stringify(data) === JSON.stringify(saved.value)) {
    alert("Ничего не изменилось");
  } else {
    try {
      const res = (await AdminFetcher.patch({
        path: "/key-value-settings",
        payload: data,
      })) as typeof data;
      saved.value = JSON.parse(JSON.stringify(res));
      data.summary_prompt = res.summary_prompt;
      data.split_full_text_prompt = res.split_full_text_prompt;
      data.max_char = res.max_char;
      data.model = res.model;
      toastOk("Успешно");
    } catch {
      toastErr("Ошибка сохранения");
    }
  }
};
const changed = computed(() => {
  return JSON.stringify(data) !== JSON.stringify(saved.value);
});
</script>
<template>
  <AdminLayout>
    <div class="settings-page">
      <form id="settingsForm">
        <div class="form-group">
          <label for="promptSummary">Основной промпт резюмирования</label>
          <textarea
            id="promptSummary"
            name="promptSummary"
            v-model="data.summary_prompt"
            placeholder="Введите промпт"
          ></textarea>
          <small class="hint"
            >Должно содержать {$1} для подстановки текста</small
          >
        </div>

        <div class="form-group">
          <label for="promptShorten">Промпт для укорачивания текста</label>
          <textarea
            id="promptShorten"
            name="promptShorten"
            v-model="data.split_full_text_prompt"
            placeholder="Введите промпт"
          ></textarea>
          <small class="hint">
            Должно содержать {$1} для подстановки величины уменьшения в % и {$2}
            - для фрагмента текста
          </small>
        </div>

        <div class="form-group">
          <label for="maxChars">Максимальное кол-во символов запроса</label>
          <input
            type="number"
            id="maxChars"
            name="maxChars"
            v-model="data.max_char"
            placeholder="Введите число"
          />
        </div>

        <div class="form-group">
          <label for="modelName">Название модели</label>
          <input
            type="text"
            id="modelName"
            name="modelName"
            v-model="data.model"
            placeholder="Введите название модели"
          />
        </div>
      </form>
    </div>

    <!-- Нижний бар всегда виден, высота 56px -->
    <div class="bottom-bar">
      <div style="flex: 1"></div>
      <button type="submit" @click="saveSettings" :disabled="!changed">
        Сохранить
      </button>
    </div>
  </AdminLayout>
</template>
<style lang="scss" scoped>
.avaliable-models {
  & p {
    margin-bottom: 0px;
  }

  & ul {
    margin-top: 0px;
  }

  & .context-l {
    color: #888;
  }
}
.settings-page {
  padding: 20px;
}

.settings-page form {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 0 auto;
}

.settings-page .form-group {
  margin-bottom: 1rem;
}

.settings-page .form-group label {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  color: #555;
}

input.invalid {
  border-color: #ff0000 !important;
}

.invalid-message {
  color: #ff0000;
  font-size: 0.8rem;
}

.settings-page .form-group input,
.settings-page .form-group textarea {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: border-color 0.3s;
  font-size: 1rem;
}

.settings-page .form-group input:focus,
.settings-page .form-group textarea:focus {
  border-color: #5b9bd5;
  outline: none;
}

.settings-page .form-group textarea {
  min-height: 100px;
  resize: vertical;
}

.settings-page .form-group .hint {
  display: block;
  margin-top: 0.5rem;
  font-size: 0.8rem;
  color: #888;
}

/* Нижний бар (фиксированный внизу) */
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: #fff;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  padding: 0 20px;
}

/* Правильное позиционирование кнопки "Сохранить" */
.bottom-bar button {
  padding: 8px 12px;
  border: none;
  background: #5b9bd5;
  color: #fff;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:disabled {
    background: #a4a4a4;
  }
}

.bottom-bar button:hover:not(:disabled) {
  background-color: #4a8ac2;
}
</style>
